import { StyleSheet } from 'react-native'
import { useStore } from 'zens-store'
import { Text, TextProps, shortLocalizedDate, localizedTime } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {},
})

interface Props extends TextProps {
  date: Date
}

const LoggingDate = (props: Props) => {
  const { date, style, ...otherProps } = props
  const { i18n } = useStore()

  return (
    <Text style={[styles.container, style]} {...otherProps}>
      {shortLocalizedDate(date, i18n.language)} <Text level={5}>{localizedTime(date, i18n.language)}</Text>
    </Text>
  )
}

export default LoggingDate
